export const toc = (() => {
  document.addEventListener('DOMContentLoaded', () => {
    if (window.innerWidth <= 994) {
      const ul = document.querySelector('.list-of-contents');
      if (!ul) return; // Exit if the list is not found

      const liItems = ul.querySelectorAll('li');

      // Only apply toggle if there are more than 5 items
      if (liItems.length > 5) {
        // Hide all li items after the first five
        liItems.forEach((item, index) => {
          if (index >= 5) {
            item.style.display = 'none';
          }
        });

        // Create the toggle button with the required classes
        const toggleBtn = document.createElement('button');
        toggleBtn.classList.add('btn', 'btn--sm', 'btn--secondary', 'list-of-contents-btn');
        toggleBtn.textContent = 'Visa hela innehållsförteckningen';

        // Insert the button after the ul
        ul.parentNode.insertBefore(toggleBtn, ul.nextSibling);

        // When the button is clicked, show all li items and remove the button
        toggleBtn.addEventListener('click', () => {
          liItems.forEach(item => {
            item.style.display = ''; // Resets to default display (usually "list-item")
          });
          toggleBtn.remove();
        });
      }
    }
  });
})();
